import handleNotOkResponse from "@jnctn/error-handling/handleNotOkResponse";
import { FetchUnauthorizedRequest } from "@jnctn/error-handling/Errors";

export type Location = {
  locationId: number;
  clientName: string;
  clientId: number;
  private: string;
  locationName: string;
  locationType: string;
  locationBuffer: string;
  point: string;
  description: string;
  primaryContact: string;
  contactPhone: string;
  contactEmail: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  postCode: string;
  country: string;
  gln: string;
  did: string;
  createdAt: string;
  createdBy: number;
  attestationEnabled: boolean;
  statementEnabled: boolean;
};

export type Result = {
  pages: Array<Location>;
  totalRows: number;
};

export function getTotal(response: Result): number {
  return response.totalRows;
}

export default async function fetchLocations(
  skip: number,
  top: number,
  accessToken: string | undefined,
  tenantId: string | undefined,
  search?: string | undefined,
  dids?: Array<string> | undefined
): Promise<Result> {
  let res: Response | undefined;
  if (accessToken === undefined || tenantId === undefined) {
    return { pages: [], totalRows: 0 };
  }

  try {
    res = await fetch(
      `${process.env.REACT_APP_QUERY_API_URL}/app/location/filter`,
      {
        method: "POST",
        credentials: "include",
        mode: "cors",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          "JNCTN-TENANT-ID": tenantId,
        },
        body: JSON.stringify({
          skip,
          top,
          filter: {
            search,
            dids,
          },
          orders: [
            {
              column: "LocationId",
              direction: "Asc",
              rank: 0,
            },
          ],
        }),
      }
    );
  } catch (error) {
    throw new FetchUnauthorizedRequest(fetchLocations, "Unauthorized");
  }

  if (!res.ok) {
    handleNotOkResponse(res, fetchLocations);
  }

  return await res.json();
}
